export const GENDER = {
  male: 'Male',
  female: 'Female',
};
